changingTextHandler = {
    $panelChangingText = $('.panel-changing-text'),
    $changeText = $('.change-text'),
    $gridChangingText = $('.grid-changing-text'),

    init = function(){
        var self = this;
        gsap.registerPlugin(TextPlugin, EasePack);

        this.$panelChangingText.each(function(){
            var $changeText = $(this).find('.change-text');
            var $text = $(this).find('.temp-text').text();
            
            if ($text) {
                animateHandler.animateFlipText($changeText, $text);
            }
 
        })

        animateHandler.animateParallax(this.$gridChangingText, false, true);

    }
}